import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AboutBook from "./pages/AboutBook";
import AboutAuthors from "./pages/AboutAuthors";
import MediaEvents from "./pages/MediaEvents";
import BuyBook from "./pages/BuyBook";
import Contact from "./pages/Contact";
import Unsubscribe from "./pages/Unsubscribe";
import AdminBookCover from "./pages/AdminBookCover";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

function App() {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(() => !!localStorage.getItem('adminToken'));

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('adminToken');
    if (token) {
      setIsAdminAuthenticated(true);
    }
  }, []);

  // Remove any dynamically injected badges
  useEffect(() => {
    const removeBadge = () => {
      const badge = document.getElementById('emergent-badge');
      if (badge) badge.remove();
      document.querySelectorAll('a[href*="emergent.sh"]').forEach(el => el.remove());
    };
    removeBadge();
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  const ProtectedRoute = ({ children }) => {
    return isAdminAuthenticated ? children : <Navigate to="/admin/login" />;
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes with Header/Footer */}
          <Route path="/" element={
            <>
              <Header />
              <Home />
              <Footer />
            </>
          } />
          <Route path="/about-the-book" element={
            <>
              <Header />
              <AboutBook />
              <Footer />
            </>
          } />
          <Route path="/about-the-authors" element={
            <>
              <Header />
              <AboutAuthors />
              <Footer />
            </>
          } />
          <Route path="/media-events" element={
            <>
              <Header />
              <MediaEvents />
              <Footer />
            </>
          } />
          <Route path="/buy" element={
            <>
              <Header />
              <BuyBook />
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Header />
              <Contact />
              <Footer />
            </>
          } />
          <Route path="/unsubscribe" element={
            <>
              <Header />
              <Unsubscribe />
              <Footer />
            </>
          } />

          {/* Admin Routes (No Header/Footer) */}
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          
          <Route path="/admin/login" element={
            <AdminLogin onLogin={() => setIsAdminAuthenticated(true)} />
          } />
          
          <Route path="/admin/dashboard/*" element={
            <ProtectedRoute>
              <AdminDashboard onLogout={() => setIsAdminAuthenticated(false)} />
            </ProtectedRoute>
          } />

          {/* Legacy admin route */}
          <Route path="/admin/book-cover" element={<AdminBookCover />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

